import React from 'react';
import { MenuItem } from '@material-ui/core';
import { selectValueType, TSelectOptionData } from '../common/types';
import { getArrayWithoutElementAtIndex } from 'src/utils/helpers';
import { SelectOption } from './SelectOption';

const MemoizedSelectOption = React.memo(SelectOption);

type PMultiSelectOption = {
  index: number;
  style: any;
  data: TSelectOptionData;
};

export const MultiSelectOption: React.FC<PMultiSelectOption> = (props) => {
  // Data - props passed from react-window library
  const { index, data, style } = props;
  const { selected, onClick } = data;

  const option = data.options[index];
  const handleClick = () => {
    const indexOfElInSelected = selected.findIndex(
      (el: selectValueType) => el === option.value,
    );
    if (indexOfElInSelected > -1) {
      const result = getArrayWithoutElementAtIndex(
        selected,
        indexOfElInSelected,
      );
      onClick(result);
    } else {
      onClick([...selected, option.value]);
    }
  };
  return (
    <MenuItem
      style={style}
      value={option?.value}
      onClick={() => {
        handleClick();
      }}
    >
      <MemoizedSelectOption
        checked={selected.includes(option.value)}
        label={option.label}
      />
    </MenuItem>
  );
};
